import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/returns.scss";

function Returns() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <main className="policy-page returns">
      <header className="policy-page__hero">
        <div>
          <p className="policy-page__kicker">Client care / Returns</p>
          <h1>Returns and refunds</h1>
        </div>
        <div className="policy-page__intro">
          <p>
            We hope every piece earns its place. If it does not, notify us within
            14 calendar days after delivery and follow the steps below.
          </p>
          <span>Last updated / August 2026</span>
        </div>
      </header>

      <div className="policy-page__layout returns__layout">
        <aside className="policy-page__aside">
          <p className="policy-page__kicker">At a glance</p>
          <dl className="returns__facts">
            <div><dt>Notice window</dt><dd>14 calendar days</dd></div>
            <div><dt>Return shipping</dt><dd>Paid by customer</dd></div>
            <div><dt>Refund processing</dt><dd>5–6 business days</dd></div>
          </dl>
        </aside>

        <article className="policy-page__content">
          <section className="returns__notice" aria-labelledby="return-start">
            <p className="policy-page__section-number">Start a return</p>
            <h2 id="return-start">Contact us before sending anything.</h2>
            <p>
              Email <a href={`mailto:${siteConfig.contact.email}`}>
                {siteConfig.contact.email}
              </a> within 14 calendar days of delivery. Include your order number,
              the item you wish to return and the reason. We will reply with return
              instructions and the correct destination.
            </p>
            <p>
              Please do not send a parcel to the studio address without an
              authorisation. Unidentified parcels may be delayed or returned.
            </p>
          </section>

          <section aria-labelledby="return-steps">
            <p className="policy-page__section-number">01</p>
            <h2 id="return-steps">Return steps</h2>
            <ol className="returns__steps">
              <li><span>01</span><div><strong>Request</strong><p>Notify client care within 14 days of receiving the order.</p></div></li>
              <li><span>02</span><div><strong>Pack</strong><p>Use secure protective packaging and include the requested order details.</p></div></li>
              <li><span>03</span><div><strong>Send</strong><p>Choose a tracked service and retain the receipt until the refund is complete.</p></div></li>
              <li><span>04</span><div><strong>Review</strong><p>We inspect the item and email you when the return is accepted.</p></div></li>
            </ol>
          </section>

          <section>
            <p className="policy-page__section-number">02</p>
            <h2>Return condition</h2>
            <p>
              Items must be unworn beyond a careful indoor fitting, unwashed,
              unaltered and returned with original tags and accessories. Take care
              to avoid fragrance, make-up, pet hair or damage. Footwear should be
              tried on a clean protected surface and returned with its original box.
            </p>
            <p>
              Unless mandatory law provides otherwise, personalised goods,
              sealed hygiene-sensitive items once opened, and items clearly marked
              final sale cannot be returned for change of mind. Faulty or
              misdescribed goods remain covered by applicable legal rights.
            </p>
          </section>

          <section>
            <p className="policy-page__section-number">03</p>
            <h2>Return shipping</h2>
            <p>
              For a change-of-mind return, you arrange and pay the return shipping.
              Original express-delivery upgrades and return postage are not
              refundable unless required by law. Use a tracked and adequately
              insured service: the parcel remains your responsibility until it
              reaches the authorised return destination.
            </p>
            <p>
              If an item arrived damaged, faulty or different from your order,
              contact us before shipping. After review, we will provide an
              appropriate solution and cover reasonable return costs where required.
            </p>
          </section>

          <section>
            <p className="policy-page__section-number">04</p>
            <h2>Refund timing</h2>
            <p>
              Once an eligible return is received and accepted, we process the
              refund to the original payment method within 5–6 business days. Your
              bank or payment provider may need additional time to display it.
            </p>
            <p>
              If a returned item shows handling beyond what is needed to assess
              fit and character, applicable law may allow a deduction for lost
              value. We will explain any proposed adjustment before completing the
              refund.
            </p>
          </section>

          <section>
            <p className="policy-page__section-number">05</p>
            <h2>Exchanges and order issues</h2>
            <p>
              Direct exchanges are not guaranteed because stock changes quickly.
              The clearest route is to return the original item and place a new
              order for the preferred size or colour. Contact client care promptly
              if your parcel is incomplete, damaged or appears to have been opened.
            </p>
          </section>

          <nav className="policy-page__related" aria-label="Return support links">
            <Link to="/shipping" onClick={toTop}>Read shipping information</Link>
            <Link to="/contact" onClick={toTop}>Contact client care</Link>
            <Link to="/terms" onClick={toTop}>Terms and conditions</Link>
          </nav>
        </article>
      </div>
    </main>
  );
}

export default Returns;
